import ease from "../../../Assets/Img/ease.jpeg";
import stock from "../../../Assets/Img/stock.webp";
// import support from "../../../Assets/Img/support.webp";
import founder from "../../../Assets/Img/founder.webp";
import motivated from "../../../Assets/Img/motivated.webp";
import ongoing from "../../../Assets/Img/ongoing.jpeg";
import focus from "../../../Assets/Img/focus.webp";

const Data=[
    {
        Img:focus,    
        heading:"GROWTH FOCUS",
        text:"Growth is the driving reason why you invest in technology. Hence, growing your business is our primary focus when working with you"
    },
    {
        Img:stock,    
        heading:"Better Stock Control",
        text:"Digitizing your stock documents as well as better visibility of your stock movements means taking control of your stock."
    },
    {
        Img:stock,    
        heading:"Dedicated Support",
        text:"We have a dedicated team to support the implementation of the project from the start. The team will be available everyday during that period."
    },
    
    {
        Img:ease,    
        heading:"Dedicated Support",
        text:"We have a dedicated team to support the implementation of the project from the start. The team will be available everyday during that period."
    },
    {
        Img:motivated ,    
        heading:"Ease of Use",
        text:"We constantly find ways to automate your work and we make that our system is easy to operate. If not, we’ll automate it further."
    },
    {
        Img:ongoing,    
        heading:"Motivated Workforce",
        text:"More automation means less mundane work, that leads to a more motivated worksforce as they perform more value added work."
    },
]
export default Data;